import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "track-nav" }
const _hoisted_2 = { class: "track" }
const _hoisted_3 = { class: "controls" }
const _hoisted_4 = { class: "title text-body-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["spot", { invisible: !_ctx.showPrevious }]),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handlePreviousClick && _ctx.handlePreviousClick(...args)))
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["line", { invisible: !_ctx.showPrevious }])
      }, null, 2),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "spot active" }, null, -1)),
      _createElementVNode("div", {
        class: _normalizeClass(["line", { invisible: !_ctx.showNext }])
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["spot", { invisible: !_ctx.showNext }]),
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleNextClick && _ctx.handleNextClick(...args)))
      }, null, 2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_font_awesome_icon, {
        icon: "chevron-left",
        class: _normalizeClass({ invisible: !_ctx.showPrevious }),
        onClick: _ctx.handlePreviousClick
      }, null, 8, ["class", "onClick"]),
      (_ctx.showPrevious || _ctx.showNext)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["title-container", { editable: _ctx.canEdit }])
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createTextVNode(_toDisplayString(_ctx.currentItem) + " ", 1),
              (_ctx.canEdit)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "title__edit",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleEditItem && _ctx.handleEditItem(...args)))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: "pen" })
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2))
        : _createCommentVNode("", true),
      _createVNode(_component_font_awesome_icon, {
        icon: "chevron-right",
        class: _normalizeClass({ invisible: !_ctx.showNext }),
        onClick: _ctx.handleNextClick
      }, null, 8, ["class", "onClick"])
    ])
  ]))
}